/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Table, Icon, Divider, Message, Card, Popup } from 'semantic-ui-react';
import { commaFormatted } from '../../utils/formatting';


const assetTableStyles = {
  padding: 0,
};

const loadingShopifyCardStyle = {
  padding: '120px 0',
  color: 'gray',
};

const totalRowStyle = {
  background: '#EEE',
};

const boldFontStyle = { fontWeight: 'bold' };

const to2Decimal = num => _.round(num, 2).toFixed(2);

const LineItems = items => <Table.Cell width={2}>
  {_.map(items, item => <div>{item}</div>)}
</Table.Cell>;

const TotalsRow = orders => {
  const currency = _.get(_.head(orders), 'orderCurrency', '');
  const totalOrders = _.sumBy(_.values(orders), order => _.get(order, 'orderTotal'));
  const totalCommission = _.sumBy(_.values(orders), order => _.get(order, 'orderCommission'));

  return (
    <Table.Row textAlign="center" style={boldFontStyle}>
      <Table.Cell><b>Totals</b></Table.Cell>
      <Table.Cell>-</Table.Cell>
      <Table.Cell>-</Table.Cell>
      <Table.Cell style={totalRowStyle}>
        <Popup
          trigger={<span>{currency} {commaFormatted(totalOrders)}</span>}
          content={`currency: ${currency}`}
        />
      </Table.Cell>
      <Table.Cell style={totalRowStyle}>
        <Popup
          trigger={<span>{currency} {commaFormatted(totalCommission)}</span>}
          content={`currency: ${currency}`}
        />
      </Table.Cell>
      <Table.Cell>-</Table.Cell>
    </Table.Row>
  );
};


class ShopifyTable extends React.Component {
  //
  constructor(props) {
    super(props);
    const { hasDiscountCodes, orders } = this.props;
    this.state = {
      shopifyLoading: false,
      hasDiscountCodes,
      orders,
    };
  }

  componentWillMount() {

  }

  render = () => {
    const {
      shopifyLoading,
      hasDiscountCodes,
      orders,
    } = this.state;

    return (
      <div>
        {
          // hasAssets &&
          <Table celled fixed singleLine basic="very" style={assetTableStyles} size="small" textAlign="center">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell width={1}>Order</Table.HeaderCell>
                <Table.HeaderCell width={2}>Items</Table.HeaderCell>
                <Table.HeaderCell width={1}>Discount Code</Table.HeaderCell>
                <Table.HeaderCell width={1}>
                  $ Total
                </Table.HeaderCell>
                <Table.HeaderCell width={1}>
                  $ Commission
                </Table.HeaderCell>
                <Table.HeaderCell width={1}>Order Date</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>

              { !shopifyLoading && hasDiscountCodes && !_.isEmpty(orders) &&
                    _.map(orders, order => <Table.Row>
                      <Table.Cell width={1}>{order.name}</Table.Cell>
                      {LineItems(order.lineItems)}
                      <Table.Cell width={1}>{order.discountCode}</Table.Cell>
                      <Table.Cell width={1}>{order.orderCurrency} {to2Decimal(order.orderTotal)}</Table.Cell>
                      <Table.Cell width={1}>{order.orderCurrency} {to2Decimal(order.orderCommission)}</Table.Cell>
                      <Table.Cell width={1}>{_.head(_.split(order.orderDate, 'T'))}</Table.Cell>
                    </Table.Row>)
              }

              { !shopifyLoading && hasDiscountCodes && !_.isEmpty(orders) &&
                TotalsRow(orders)
              }

              { !shopifyLoading && hasDiscountCodes && _.isEmpty(orders) &&
                <Table.Row>
                  <Table.Cell colSpan="6">
                    <Message>
                    No sales during the campaign period
                    </Message>
                  </Table.Cell>
                </Table.Row>
              }

              { !shopifyLoading && !hasDiscountCodes &&
                <Table.Row>
                  <Table.Cell colSpan="6">
                    <Message>
                      Please enter a discount code
                    </Message>
                  </Table.Cell>
                </Table.Row>
              }

              { shopifyLoading &&
              <Table.Row>
                <Table.Cell colSpan="6">
                  <Card.Content textAlign="center" style={loadingShopifyCardStyle}>
                    <Icon name="refresh" loading size="huge" />
                    <Divider hidden />
                  Loading orders
                  </Card.Content>
                </Table.Cell>
              </Table.Row>
              }

            </Table.Body>
          </Table>
        }

        {/* {
          !hasAssets &&
          <Table celled fixed singleLine basic="very" style={assetTableStyles} size="small" textAlign="center">
            <Table.Body>

            </Table.Body>
          </Table>
        } */}
      </div>
    );
  }
}

ShopifyTable.propTypes = {
  orders: PropTypes.object,
  hasDiscountCodes: PropTypes.bool,
};

ShopifyTable.defaultProps = {
  hasDiscountCodes: true,
  orders: [],
};

export default ShopifyTable;




/** WEBPACK FOOTER **
 ** ./src/components/shopify-table/index.js
 **/